import { render, staticRenderFns } from "./PopUpImage.vue?vue&type=template&id=2333815a&"
import script from "./PopUpImage.vue?vue&type=script&lang=js&"
export * from "./PopUpImage.vue?vue&type=script&lang=js&"
import style0 from "./PopUpImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports